import React from 'react';
import {
  Text,
} from '@fluentui/react-northstar';
import { ApprovalCard } from './TicketRequestCard';
import { TablePagination } from '../../../shared/components/table/TablePagination';
import { useHistory } from 'react-router-dom';
import { MyWorkListViewType, TicketApprovalState } from '../../../shared/utils/constants';
import { useTranslation } from 'react-i18next';
import { useSetState } from '../../../AppState';
import { ResultCount } from '../../../shared/components/ResultCount';

interface Props {
  paginatedApprovals: any[],
  column: number,
  userId: number,
  pagination: {
    currentPage: number,
    totalCount: number,
    moveToPage: (type: string) => void,
    itemPerPage: number,
    itemsPerPageChanged?: (itemPerPage: number) => void
  }
  onUpdate: (approvalId: number, approverId: number, status: TicketApprovalState, approvalState: TicketApprovalState) => void
}

export const ApprovalColumn = ({ paginatedApprovals, column, userId, pagination, onUpdate }: Props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const setAppState = useSetState();

  return (
    <>
      <div className="overflow-auto request-column-ticket md:request-column-ticket">
        {paginatedApprovals.map((ticketApproval: any) => (
          <div onClick={() => {
            setAppState(prev => ({ ...prev, selectedTaskOrApproval: { type: MyWorkListViewType.Approvals, id: ticketApproval.TicketId } }));
            history.push(`/requests/${ticketApproval.TicketId}`)
          }} className='cursor-pointer'>
            <ApprovalCard key={ticketApproval.Id} ticket={ticketApproval.Ticket} view='list' approvalProps={{ approval: ticketApproval, userId: userId }} onUpdate={onUpdate} />
          </div>
        ))}
      </div>
      <div className="flex items-center">
        <ResultCount count={pagination.totalCount} />
        <TablePagination currentPage={pagination.currentPage} totalCount={pagination.totalCount} moveToPage={pagination.moveToPage} itemsPerPage={pagination.itemPerPage} itemsPerPageChanged={pagination.itemsPerPageChanged} />
      </div>
    </>
  )
}